import { render, staticRenderFns } from "./AreaSelector.vue?vue&type=template&id=226a8598&"
import script from "./AreaSelector.vue?vue&type=script&lang=js&"
export * from "./AreaSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports